import React, {useEffect, useState} from 'react';
import {Button, Checkbox, Form, Input, Modal, Table, theme, Typography} from "antd";
import {ColumnsType} from "antd/es/table";
import {QueryKey, useQueryClient} from "@tanstack/react-query";

import Search from "antd/es/input/Search";
import {useCommonUseMutation, useCommonUseQuery} from "../../../../../Common/hooks/rest/ReacQueryHook";
import {procAdminService} from "../../../../../Common/util/ProcService";
import {TB_BATCH_JOB} from "./data/TB_BATCH_JOB";
import {EditOutlined} from "@ant-design/icons";
import CronMaker from "../../common/component/CronMaker/CronMaker";
import "../../common/css/Input.css"

const { Text } = Typography;

interface searchText  {
    searchText : string,
}

const BatchMgr: React.FC = () => {
    const { token: { colorBgContainer },} = theme.useToken();

    const queryClient = useQueryClient();
    const queryKey:QueryKey =   [`BatchMgr`];
    const serviceCode:string       =   process.env.REACT_APP_SERVICE_NAME as string;

    const mutateUpdate = useCommonUseMutation<any>(queryKey, queryClient
        , procAdminService);

    const [userStatusState, setUserStatusState] = useState<Record<string, boolean>>({});

    let requestParam:searchText = {
        searchText : "",
    }
    const { data, isFetching, refetch} = useCommonUseQuery<TB_BATCH_JOB[]>(
        queryKey,
        () =>procAdminService<TB_BATCH_JOB[]>("post", `${serviceCode}ADS30`, requestParam));


    const [modalTitle, setModalTitle] = useState<string>("");
    const [regModal, setRegModal] = useState<boolean>(false);
    const [updateModal,setUpdateModal] = useState<boolean>(false);
    const [jobServiceNo, setJobServiceNo] = useState<string>("");
    const [jobName, setJobName] = useState<string>("");
    const [cronExpression, setCronExpression] = useState<string>("");
    const [cronExpressionText, setCronExpressionText] = useState<string>("");
    const [sendcronExpressionText, setSendCronExpressionText] = useState<string>('');
    const [minLockMinutes, setMinLockMinutes] = useState<number>(0);
    const [maxLockMinutes, setMaxLockMinutes] = useState<number>(30);
    const [isActive, setIsActive] = useState<string>("");
    const [showDeleteBox, setShowDeleteBox] = useState<boolean>(false);


    const onRegiModal= () => {
        setModalTitle("배치 등록");
        setRegModal(true);
        setUpdateModal(false);
        setJobServiceNo("");
        setJobName("");
        setCronExpression("0 0/10 * 1/1 * ?");
        setCronExpressionText("10분 마다 실행");
        setSendCronExpressionText("10분 마다 실행");
        setMinLockMinutes(0);
        setMaxLockMinutes(30);
        setIsActive("1");
    }

    const onUpdateModal= (record:TB_BATCH_JOB) => {
        setModalTitle("배치 수정");
        setRegModal(true);
        setUpdateModal(true);
        setJobServiceNo(record.jobServiceNo);
        setJobName(record.jobName);
        setCronExpression(record.cronExpression);
        setCronExpressionText(record.cronExpressionText);
        setSendCronExpressionText(record.cronExpressionText);
        setMinLockMinutes(record.minLockMinutes);
        setMaxLockMinutes(record.maxLockMinutes);
        setIsActive(record.isActive);
    }

    const onDelete = (record:TB_BATCH_JOB) => {

        Modal.confirm({
            title: `${record.jobName}(${record.jobServiceNo}) 배치를 삭제하시겠습니까?`,
            content: "삭제 후에는 복구되지 않습니다.",
            open: showDeleteBox,
            okText: "확인",
            cancelText: "취소",
            onOk() {
                setShowDeleteBox(false);

                const saveBatchParam : TB_BATCH_JOB =            {
                    jobServiceNo:record.jobServiceNo,
                    jobName:record.jobName,
                    cronExpression:record.cronExpression,
                    cronExpressionText:record.cronExpressionText,
                    minLockMinutes:record.minLockMinutes,
                    maxLockMinutes:record.maxLockMinutes,
                    isActive:record.isActive
                }

                const updateParam = { method: 'post', serviceCode: `${serviceCode}ADD30`, requestBody:saveBatchParam }
                return mutateUpdate.mutateAsync(updateParam)
                    .catch(error => {
                        console.error(error);

                    }).finally(() => {
                });
            },
            onCancel() {
                setShowDeleteBox(false);
            },
        });

    }

    const onChangeJobServiceNo = (e:any) => {
        setJobServiceNo(e.target.value);
    }
    const onChangeJobName = (e:any) => {
        setJobName(e.target.value);
    }
    const onChangeMinLockMinutes = (e:any) => {
        setMinLockMinutes(e.target.value);
    }
    const onChangeMaxLockMinutes = (e:any) => {
        setMaxLockMinutes(e.target.value);
    }

    const setCronExp = (value:string) => {
        setCronExpression(value);
    }

    const setCronExpTxt = (value:string) => {
        setCronExpressionText(value);
    }



    const onCancelModal = () => {
        setRegModal(false);
    }

    const onSaveBatch = () => {
        const saveBatchParam : TB_BATCH_JOB =
            {
                jobServiceNo:jobServiceNo,
                jobName:jobName,
                cronExpression:cronExpression,
                cronExpressionText:cronExpressionText,
                minLockMinutes:minLockMinutes,
                maxLockMinutes:maxLockMinutes,
                isActive:isActive
            }
        const updateParam = { method: 'post', serviceCode: `${serviceCode}ADU30`, requestBody:saveBatchParam }
        mutateUpdate.mutateAsync(updateParam)
            .catch(error => {
                console.error(error);

            }).finally(() => {
        });
        setRegModal(false);
        setUpdateModal(false);
    }

    const onSearch = (value: string) => {
        requestParam = {
            searchText : value,
        }
        refetch();
    }

    const handleStatusChange = (record:TB_BATCH_JOB, checked: boolean) => {
        setUserStatusState((prev) => ({
            ...prev,
            [record.jobServiceNo]: checked,
        }));

        // 서버로 변경된 extensionStatus 업데이트 요청을 보낼 수도 있습니다.
        updateStatus(record, checked);
    };

    function updateStatus(record:TB_BATCH_JOB, checked:boolean)
    {
        const updateUserParam:TB_BATCH_JOB  = {
            jobServiceNo:record.jobServiceNo,
            jobName:record.jobName,
            cronExpression:record.cronExpression,
            cronExpressionText:record.cronExpressionText,
            minLockMinutes:record.minLockMinutes,
            maxLockMinutes:record.maxLockMinutes,
            isActive:checked ? '1' : '0'
        }

        const updateParam = { method: 'post', serviceCode: `${serviceCode}ADU30`, requestBody:updateUserParam }
        mutateUpdate.mutateAsync(updateParam)
            .catch(error => {
                console.error(error);

            }).finally(() => {
        })


    }

    useEffect(() => {
        // 최초 데이터 로딩 시 extensionStatusState 초기화
        if (data) {
            const initialState: Record<string, boolean> = {};
            data.forEach((item) => {
                initialState[item.jobServiceNo] = item.isActive === "1" ? true : false  || false;
            });
            setUserStatusState(initialState);
        }
    }, [data]);





    const columns: ColumnsType<TB_BATCH_JOB> = [
        {
            title: '서비스코드',
            dataIndex: 'jobServiceNo',
            key: 'jobServiceNo',
            render: (text: string, record:TB_BATCH_JOB) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'left', justifyContent: 'left' }}>
                    {text}
                </div>
            ,
        },
        {
            title: 'Job 명',
            dataIndex: 'jobName',
            key: 'jobName',
            render: (text: string,record:TB_BATCH_JOB) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {text}
                </div>
            ,
        },
        {
            title: '배치주기',
            dataIndex: 'cronExpressionText',
            key: 'cronExpressionText',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {text}
                </div>
            ,
        },
        {
            title: 'Lock 최소시간(분)',
            key: 'minLockMinutes',
            dataIndex: 'minLockMinutes',
            render: (text: number)=>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {text}분
                </div>
            ,
        },
        {
            title: 'Lock 최대시간(분)',
            key: 'maxLockMinutes',
            dataIndex: 'maxLockMinutes',
            render: (text: number) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {text}분
                </div>
            ,
        },
        {
            title: '활성화여부',
            key: 'isActive',
            dataIndex: 'isActive',
            render: (text: boolean, record:TB_BATCH_JOB) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Checkbox
                        checked={userStatusState[record.jobServiceNo]}
                        onChange={(e) => handleStatusChange(record, e.target.checked)}
                    />
                </div>
            ,
        },
        {
            title: '',
            key: 'Active',
            dataIndex: 'Active',
            render: (text, record:TB_BATCH_JOB) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Button type="link" size="small" onClick={(e) => onUpdateModal(record)}>수정</Button>
                    <Button type="link" size="small" onClick={(e) => onDelete(record)}>삭제</Button>
                </div>
            ,
        },
    ];

    const fields = [
        { name: ['jobServiceNo'], value: jobServiceNo },
        { name: ['jobName'], value: jobName },
        { name: ['cronExpression'], value: cronExpression },
        { name: ['cronExpressionText'], value: cronExpressionText },
        { name: ['minLockMinutes'], value: minLockMinutes },
        { name: ['maxLockMinutes'], value: maxLockMinutes },
        { name: ['isActive'], value: isActive },


    ];


    return (
        <>
        <nav style={{
            margin:'0px 0px 14px 0px',
            padding:'9px 8px 9px 0px',
            height: '50px',
            display:'flex',
            justifyContent: "space-between",
            alignItems:'center',
            borderRadius: "8px", // 라운드 처리 추가
            border: '1px solid #dadada',
            background: colorBgContainer,
        }}>
            <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{
                    padding: '9px 5px',
                    display:'flex',
                }}>
                </div>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
                <Button style={{marginRight:"10px"}} type={"primary"} onClick={onRegiModal}>배치등록</Button>
                <Search placeholder="서비스코드 or Job명" allowClear onSearch={onSearch} style={{ width: 210 }} />
            </div>
        </nav>
        <Table columns={columns}
                dataSource={data}
                rowKey="jobServiceNo"
                loading={isFetching}
        />
        <Modal
            open={regModal}
            title={modalTitle}
            onCancel={onCancelModal}
            footer={[
                <></>
            ]}
        >
            <Form
                name="saveBatch"
                initialValues={{
                    remember: false,
                }}
                fields={fields}
                onFinish={onSaveBatch}
            >
                <Form.Item
                    name="jobServiceNo"
                    rules={[
                        {
                            required : updateModal ? false : true,
                        },
                    ]}
                >
                    {updateModal ?
                    <Input
                        readOnly
                        prefix={<EditOutlined className="site-form-item-icon" />}
                        placeholder="서비스코드"
                        value={jobServiceNo}
                        onChange={onChangeJobServiceNo}
                    />
                    :
                    <Input
                        prefix={<EditOutlined className="site-form-item-icon" />}
                        placeholder="서비스코드"
                        value={jobServiceNo}
                        onChange={onChangeJobServiceNo}
                    />}
                </Form.Item>
                <Form.Item
                    name="jobName"
                    rules={[
                        {
                            required : true,
                        },
                    ]}
                >
                    <Input
                        prefix={<EditOutlined className="site-form-item-icon" />}
                        placeholder="Job 명"
                        value={jobName}
                        onChange={onChangeJobName}
                    />

                </Form.Item>
                <CronMaker
                    setCronExpression={setCronExp}
                    revCronExpressionText={sendcronExpressionText}
                    setCronExpressionText={setCronExpTxt} />
                <div style={{margin:"10px"}}>배치주기 : <Text keyboard>{cronExpressionText}</Text></div>
                <Form.Item
                    name="minLockMinutes"
                    rules={[
                        {
                            required : true,
                        },
                    ]}
                >
                    <Input
                        prefix={<EditOutlined className="site-form-item-icon" />}
                        placeholder="Lock 최소시간(분)"
                        value={minLockMinutes}
                        onChange={onChangeMinLockMinutes}
                        type={"number"}
                    />
                </Form.Item>
                <Form.Item
                    name="maxLockMinutes"
                    rules={[
                        {
                            required : true,
                        },
                    ]}
                >
                    <Input
                        prefix={<EditOutlined className="site-form-item-icon" />}
                        placeholder="Lock 최대시간(분)"
                        value={maxLockMinutes}
                        onChange={onChangeMaxLockMinutes}
                        type={"number"}
                    />
                </Form.Item>

                <Form.Item
                    name="isActive"
                >

                    <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'left', justifyContent: 'left' }}>
                        활성화 여부 : <Checkbox
                            style={{marginLeft:"10px"}}
                            checked={isActive === '1' ? true : false}
                            onChange={(e) => setIsActive(e.target.checked ? '1' : '0')}
                        />
                    </div>
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit" className="login-form-button">
                        적용
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
        </>
    );
};

export default BatchMgr;
